import { render, staticRenderFns } from "./CoralsolDaforTable.vue?vue&type=template&id=4550d091&"
import script from "./CoralsolDaforTable.vue?vue&type=script&lang=js&"
export * from "./CoralsolDaforTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports